import React, { FC, useState, useMemo } from 'react'
import MobileHeader from './MobileHeader/MobileHeader'
import DesktopHeader from './DesktopHeader/DesktopHeader'
import { HeaderProvider, MobileHeaderConfig } from './HeaderContext'
import { NavigationLinks } from './NavigationLinks'
import CartUrgencyBar from 'components/CartUrgencyBar'
import styles from './Header.module.scss'
import { transformNavigationLinks } from './helpers'
import { useSelector } from 'react-redux'
import { getUserPreferencesSelectedCurrency } from 'selectors/user/cookie'

const Header: FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const [mobileHeaderConfig, setMobileHeaderConfig] = useState<MobileHeaderConfig>({
    mobileTopHeader: 'mainTopHeader',
    mobileMenuContent: 'null',
    isMobileMenuOpen: false,
  })

  const localeCurrency = useSelector(getUserPreferencesSelectedCurrency)

  const transformedNavigationLinks = useMemo(() => {
    return transformNavigationLinks({
      navigationLinks: NavigationLinks,
      localeCurrency,
    })
  }, [localeCurrency])

  return (
    <HeaderProvider
      value={{
        selectedCategory,
        setSelectedCategory,
        mobileHeaderConfig,
        setMobileHeaderConfig,
        navigationLinks: transformedNavigationLinks,
      }}
    >
      <MobileHeader />
      <DesktopHeader />
      <div className={styles.cartUrgencyBox}>
        <CartUrgencyBar />
      </div>
    </HeaderProvider>
  )
}

export default Header
